import { Button } from "@mui/material";
import LocalNav from "../NavBar/LocalNav";
import { COLORS } from "../../../context/initialValues";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer/ReportFooter";

import "./styles/Report.css";

const ExamResultsCard = ({ name, score }) => {
  const navigate = useNavigate()
  function restartExam(e) {
    e.preventDefault();
    const encodedName = encodeURIComponent(name);
    navigate(`/${encodedName}/`);
  }
  return (
    <div className="report-card-container">
      <div
        className="local report-card"
        style={{ borderTop: `4px solid ${COLORS[2].border}` }}
      >
        <div>
          <h4>{name}</h4>
          <p className="mb-0">
            Try signing up and creating your own exam to have access to
            evaluation reports. Try again below for a better score.
          </p>
        </div>
        <b className="score">{score}%</b>
        <div>
          <Button
            onClick={restartExam}
            variant="contained"
            color="ghostBlack"
            disableElevation
            className="px-4 py-2"
          >
            Try Again
          </Button>
        </div>
      </div>
    </div>
  );
};

const LocalReportContent = ({ name, score }) => {
  const navigate = useNavigate();
  function goHome() {
    navigate("/");
  }
  function restartExam(e) {
    e.preventDefault();
    const encodedName = encodeURIComponent(name);
    navigate(`/${encodedName}/`);
  }
  return (
    <>
      <LocalNav examName={name} />
      <ExamResultsCard name={name} score={score} />
      <Footer onHomeClick={goHome} onRetryClick={restartExam} />
    </>
  );
};

export default LocalReportContent;
